export const filterEnumsArr = (arr, ...names) => {
  return arr && arr.filter(item => !names.includes(item.value));
};

// expTarget: {key: 16103, value: "承运商或车队", name: "EXPTARGET_CARRIER_FLEET"}
// 此类型的对象转换为 只获取name的字符串
export const onlyGetObjName = params => {
  const obj = {};
  for (let key in params) {
    if (params[key] && Array.prototype.toString.call(params[key]) === '[object Object]') {
      obj[key] = params[key].name ? params[key].name : params[key];
    } else {
      obj[key] = params[key];
    }
  }
  return obj;
};

export function filterObjectParams(obj, params) {
  const newObj = {};
  for (let key in obj) {
    if (!params.includes(key)) {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}

// 处理线路管理 dropTrailer
export function dealDropTrailer(arr) {
  return arr.map(itm => {
    return {
      ...itm,
      dropTrailer:
        itm.dropTrailer && typeof itm.dropTrailer === 'object'
          ? itm.dropTrailer.name
          : itm.dropTrailer || 'WHETHER_NO',
    };
  });
}

// 筛选枚举
export const getOptionDefaultValue = (data, key, enums, isApprove = false) => {
  let enumALength = 0;
  let enumBLength = 0;
  const getEnumNames = enums ? enums.map(itm => itm.name) : [];
  const datas = Array.isArray(data) ? data : [data];
  if (datas.length === 0) {
    return undefined;
  }

  datas.forEach(itm => {
    // 审核跟列表枚举不一致 单独判断

    let name = itm[key] && itm[key].name;

    if (isApprove) {
      if (name === 'AUDITSTATUS_LOSE' || name === 'AUDITSTATUS_WAIT') {
        name = 'AUDITING_STATUS__N';
      }
      if (name === 'AUDITSTATUS_ALREADY') {
        name = 'AUDITING_STATUS__Y';
      }
    }

    if (name === getEnumNames[0]) {
      enumALength++;
    }
    if (name === getEnumNames[1]) {
      enumBLength++;
    }
  });
  if (enumALength === datas.length) {
    return getEnumNames[1];
  }
  if (enumBLength === datas.length) {
    return getEnumNames[0];
  }

  return undefined;
};

// 遍历对象，保留值为1的键名
export function formatDayObjToArray(obj) {
  var arr = [];
  for (const [key, value] of Object.entries(obj)) {
    if (value) {
      arr.push(key);
    }
  }
  return arr;
}

// 线路管理-甩挂checkbox 判断枚举 true false
export function getValue(value) {
  if (value === true) {
    return 'WHETHER_YES';
  }
  if (value === false) {
    return 'WHETHER_NO';
  }
  if (value === 'WHETHER_YES') {
    return true;
  }
  if (value === 'WHETHER_NO') {
    return false;
  }
  return false;
}

// 线路管理-编辑途径地甩挂,处理出发地和目的地始终没有甩挂
export function changeValue(arr) {
  let value = arr;
  if (value.length >= 2) {
    let target1 = value[0];
    let target2 = value[value.length - 1];
    if (target1) {
      target1['dropTrailer'] = 'WHETHER_NO';
    }
    if (target2) {
      target2['dropTrailer'] = 'WHETHER_NO';
    }
  }
  return value;
}

// 大写转小写加下划线
export const changeType = str => {
  let str2 = str;
  const arr = str.split('');
  arr.forEach(item => {
    if (/[A-Z]/.test(item)) {
      str2 = str2.replace(item, `_${item.toLowerCase()}`);
    }
  });
  return str2;
};

export function getDistrictLast(value) {
  if (Array.isArray(value)) {
    return value[value.length - 1];
  }
  return value;
}

export async function inPortFile(file) {
  let formData = new FormData();
  formData.append(file.name, file);
  // formData.forEach(f => console.log('-->f', f))
  const blob = new Blob(formData);
  const fr = new FileReader();
  fr.readAsDataURL(blob);
  // fr.readAsDataURL(file);
  // loading done
  fr.onload = frdata => console.log('frdata', frdata.target.result);
  // const reust = await publicRequest(
  //   'aa/aa',
  //   { file: blob },
  //   {
  //     reqType: null,
  //     headers: { 'Content-Type': 'multipart/form-data' },
  //   }
  // )
}

export const isEmpty = text => {
  return !!text || text === 0 || text === '0';
};

/** 获取 URL参数,指定 key */
export function getUrlValueByKey(search, key) {
  //找出key第一次出现的位置
  var start = search.indexOf(key);
  if (start == -1) {
    return;
  }
  //找出key最后出现的位置
  var end = search.indexOf('&', start);
  if (end == -1) {
    end = search.length;
  }
  //取出键值对
  var str = search.substring(start, end);
  //获取getValue
  var arr = str.split('=');
  return arr?.[1] || null;
}

/** 将指定分隔符转驼峰 */
export function toHump(str, delimiter, bigHump = false) {
  let strs = str.split(delimiter);
  if (!strs.length) return str;
  if (!bigHump && strs.length == 1) return str;

  let start = bigHump ? 0 : 1;
  let temp = '';
  for (let i = start; i < strs.length; i++) {
    strs[i] = strs[i].slice(0, 1).toUpperCase() + strs[i].slice(1);
  }
  return strs.join('');
}

//判断指定double是否为0（指定精度）
export function considerZero(value, delta) {
  return Math.abs(value) <= delta;
}


/**
 * 判断字符串是否包含指定文本
 *
 * @param str 目标字符串
 * @param text 需要查找的文本
 * @returns 如果目标字符串包含指定文本，则返回true；否则返回false
 */
function stringContains(str, text) {
  return str.indexOf(text) > -1;
}

/**
 * 判断一个值是否为对象。
 *
 * 本函数通过调用Object.prototype.toString方法获取传入值的内部[[Class]]属性，
 * 并检查其是否包含'Object'字符串来确定该值是否为对象。这种方法可以可靠地识别对象，
 * 区别于仅使用typeof运算符，因为typeof null也会返回'object'。
 *
 * @param {any} a - 需要判断的值。
 * @returns {boolean} 如果传入的值是对象，则返回true；否则返回false。
 */
export const isObj = (a) => stringContains(Object.prototype.toString.call(a), 'Object');
